 

function Section2() { 
  return (
    <div  className='section-two'>
        <div className='grid grid-cols-1 tablet:grid-cols-2 w-1/2 my-52 mx-auto py-20 '>
            <div className="w-full tablet:mb-10">
                <img src='imgs/food3.jpg' className='shadow-[0px_0px_4px_6px_rgba(249,201,130)] h-80 object-cover min-w-2/5'/>
            </div>
            <div className='py-2 mt-20 tablet:mt-0'>
                <h3 className='font-font1 text-4xl text-primary mb-10'>
                    Lorem ipsum 
                </h3>
                <p className='leading-10 text-secondary text-justify'> 
                    Lorem ipsum dolor sit ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud , Lorem ipsum dolor sit ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                </p>
            </div>
        </div>
    </div>
  )
}

export default Section2